import NextGenImageWrapper from './nextGenImageWrapper'

export default NextGenImageWrapper
